export const busDomainUri = 'bus';

export const failure = `${busDomainUri}.errors.failure`;
export const busUnhandledMessage = `${busDomainUri}.errors.unhandled_message`;
